<h1 mat-dialog-title>Contacter l'ACAL</h1>
<div mat-dialog-content>


  <h3 style="text-decoration: underline;">Levalloisiens :</h3>
  <p>
    N'hésitez pas à nous contacter pour nous donner votre avis ou apporter des informations sur un commerçant.
  </p>
  <br />

  <h3 style="text-decoration: underline;">Commerçants et artisans :</h3>
  <p>
    Afin de vous référencer ou apporter des modifications concernant votre commerce, n'hésitez pas à utiliser <a style="text-decoration: underline;" href="http://actualiser.acal-levallois.fr" target="_blank">le formulaire en cliquant ici</a>.
  </p>
  <br />

  <h3 style="text-decoration: underline;">Nos coordonnées :</h3>
  <p>
    Email: <a href="mailto:contact@acal-levallois.fr">contact@acal-levallois.fr</a><br />
    Adresse : 34 rue pierre Brossolette, 92300 Levallois
  </p>

</div>
<div mat-dialog-actions>
  <a mat-button href="mailto:contact@acal-levallois.fr">Envoyer un Email</a>
  <button mat-button (click)="onNoClick()">Fermer</button>
  <!-- <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button> -->
</div>